import Column from '@components/Column';
import Row from '@components/Row';
import Text from '@components/Text';
import { OrderReceiptResponse } from '@models/order';
import dayjs from 'dayjs';

import ReceiptDivider from '../ReceiptDivider';

interface Props {
    receipt: OrderReceiptResponse;
}

function ShopInfo({ receipt }:Props) {
    const {
        shopName,
        shopContact,
        addrRoad, addrDetail,
        order, companyNo, ownerName,
    } = receipt;
    return (
        <Column fullWidth spacing={0.5}>
            <Text fontWeight='bold'>{shopName}</Text>
            <Text>{addrRoad} {addrDetail}</Text>
            <Row spacing={2}>
                <Text>{ownerName} {companyNo}</Text>
                <Text>{shopContact}</Text>
            </Row>
            <Text>{dayjs(order.orderAt).format('YYYY-MM-DD HH:mm:ss')}</Text>
            <ReceiptDivider/>
        </Column>
    );
}

export default ShopInfo;
